module.exports = __webpack_public_path__ + "media/images/cleaning/card-mobile@2x-4181b8f12f898b26dce8d320a9efbe5b.jpg";